import { Button } from "@rio-cloud/rio-uikit";
import InputDate from "../InputDate";
import { setScheduleDateSelected, setScheduleHoursSelected, useAppSelector } from "@store";
import moment from "moment";
import { useDispatch } from "react-redux";

interface Props {
    handleEditDriverTrip?: () => void;
    handleEditVehicleTrip?: () => void;
}

const DynamicTrip = ({ handleEditDriverTrip, handleEditVehicleTrip }: Props) => {
    const {
        driversSelected,
        nameVehicleSelected,
        scheduleDateSelected,
        scheduleHoursSelected
    } = useAppSelector(state => state.trips);

    const dispatch = useDispatch();

    const driversLabel = driversSelected.length === 0
        ? ''
        : driversSelected.length === 1
            ? driversSelected[0].name
            : `${driversSelected.length} motoristas selecionados`;

    return (
        <div className="padding-x-15 display-flex flex-column">
            <div className="margin-top-15">
                <label htmlFor="inputWithMask1">Veículo</label>
                <div className="display-flex width-100pct gap-15">
                    <div className="width-100pct input-group">
                        <input
                            disabled
                            type="text"
                            className="simulador-input width-100pct"
                            value={nameVehicleSelected?.toString() || ''}
                            onChange={(e) => { }}
                        />
                    </div>

                    <Button
                        bsStyle={Button.PRIMARY}
                        iconName="rioglyph rioglyph-pencil"
                        iconOnly
                        onClick={handleEditVehicleTrip}
                    />
                </div>
            </div>

            <div className="margin-top-10">
                <label htmlFor="inputWithMask1">Motorista{driversSelected.length > 1 ? 's' : ''}</label>
                <div className="display-flex width-100pct gap-15">
                    <div className="width-100pct input-group">
                        <input
                            disabled
                            type="text"
                            className="simulador-input width-100pct"
                            value={driversLabel}
                            onChange={(e) => { }}
                            title={driversSelected.map(d => d.name).join(', ')}
                        />
                    </div>

                    <Button
                        bsStyle={Button.PRIMARY}
                        iconName="rioglyph rioglyph-pencil"
                        iconOnly
                        onClick={handleEditDriverTrip}
                    />
                </div>
            </div>

            <div className="display-flex width-100pct gap-15">
                <div className="width-50pct">
                    <InputDate
                        label="Data"
                        inputProps={{ placeholder: "Selecione o dia.", id: "1" }}
                        dateFormat="DD/MM/YYYY"
                        value={moment(scheduleDateSelected?.toString()) || ''}
                        timeFormat={false}
                        onChange={(date) => dispatch(setScheduleDateSelected(moment(date).format('YYYY-MM-DD')))}
                    />
                </div>
                <div className="width-50pct">
                    <InputDate
                        label="Hora"
                        value={scheduleHoursSelected?.toString() || ''}
                        inputProps={{ placeholder: "Selecione o horário.", id: "2" }}
                        dateFormat={false}
                        onChange={(date) => dispatch(setScheduleHoursSelected(moment(date).format('HH:mm')))}
                        timeFormat="HH:mm"
                    />
                </div>
            </div>
        </div>
    )
}

export default DynamicTrip;